namespace GeniuzPOS.Purchase {
    export class PoApprovalColumns {
        static columnsKey = 'Purchase.PoApproval';
    }
}
